export default "__VITE_ASSET__Bnu9Lc46__"